import { useMemo } from 'react';
import I18n from 'i18n-js';

const useSubmitButtonName = ({ modelName, objectId, isFormSending }) => useMemo(
  () => {
    const formActionName = objectId ? 'update' : 'create';
    const waitText = I18n.t('please_wait');
    const actionText = I18n.t(['helpers.submit', modelName, formActionName]);
    const buttonName = isFormSending ? waitText : actionText;

    return buttonName;
  },
  [modelName, objectId, isFormSending],
);

export default useSubmitButtonName;
